import { useState } from "react";
import { TableCell } from "@mui/material";

const MAX_LENGTH = 40; // Adjust the max length as needed

const ExpandableTableCell = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return <TableCell>-</TableCell>;

  return (
    <TableCell
      style={{
        padding: "0 16px",
        whiteSpace: "nowrap",
        textTransform: "capitalize"
      }}
    >
      {expanded
        ? text
        : text?.length > MAX_LENGTH
        ? `${text.slice(0, MAX_LENGTH)}...`
        : text}
      {text?.length > MAX_LENGTH && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "#1976d2", // Material-UI primary color
            cursor: "pointer",
            marginLeft: 5,
            // fontWeight: "bold",
            transition: "color 0.3s"
          }}
          onMouseEnter={(e) => (e.target.style.color = "#1565c0")} // Darker blue on hover
          onMouseLeave={(e) => (e.target.style.color = "#1976d2")} // Revert on leave
        >
          {expanded ? " Show less" : " More"}
        </span>
      )}
    </TableCell>
  );
};

export default ExpandableTableCell;
